var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3064 8.625H12.418V12.703H18.64C18.3719 14.0208 17.5574 15.1374 16.333 15.8849V18.5301H20.0693C22.2554 16.6948 23.5166 13.9921 23.5166 10.7814C23.5166 10.0339 23.4431 9.31505 23.3064 8.625Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0687 18.5302L16.3324 15.885C15.2971 16.5175 13.9729 16.8913 12.4174 16.8913C9.40623 16.8913 6.85753 15.0368 5.9484 12.5449H2.08594V15.2764C3.98827 18.7218 7.89803 21.0843 12.4174 21.0843C15.5389 21.0843 18.1559 20.1403 20.0687 18.5302Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58502 10.5431C5.58502 9.84827 5.7164 9.17259 5.94762 8.54005V5.80859H2.08515C1.30215 7.23182 0.855469 8.84194 0.855469 10.5431C0.855469 12.2443 1.30215 13.8544 2.08515 15.2776L5.94762 12.5462C5.7164 11.9136 5.58502 11.238 5.58502 10.5431Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8369 5.7696L20.1528 2.74583C18.1506 1.04466 15.5336 0 12.4174 0C7.89803 0 3.98827 2.36247 2.08594 5.80793L5.94841 8.53938C6.85753 6.04753 9.40623 4.19302 12.4174 4.19302C14.1148 4.19302 15.6387 4.72493 16.8369 5.7696Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.e2523ab03711e1dfc1019ec6db8f7fc5.svg";
export { ForwardRef as ReactComponent };